import { authGet, authJsonGet, getAuth, getSavedUser, pubGet } from "functions/BaseAxios";


export const QUESTION_TRIP = 'QUESTION_TRIP';
export const QUESTION_GUIDE = 'QUESTION_GUIDE';
export const QUESTION_TRIP_GUIDE = 'QUESTION_TRIP_GUIDE';
export const QUESTION_TEXT = 'QUESTION_TEXT';
export const QUESTION_TRIP_COUNT = 'QUESTION_TRIP_COUNT';
export const QUESTION_GUIDE_COUNT = 'QUESTION_GUIDE_COUNT';
export const ANSWER_USER = 'ANSWER_USER';


let loading = true;

export function updateLoadingQuestion(id: boolean) {
    loading = id
}

export function getLoadingQuestion() {
    return loading;
}
export function getQuestionTrip(id: any, start?: any) {
    return async (dispatch: DispatchGeneral) => {
        let data, data1;
        try {
            data1 = await authGet('auth/questions/get-my-answer/' + id);
            data = await pubGet('questions-trip/' + id + '?page=' + start);
        } catch (error) {
            data = { code: 201 };
        }
        updateLoadingQuestion(false);
        dispatch({
            type: ANSWER_USER,
            payload: data1.code == 200 ? data1.payload.data : [],
        });

        dispatch({
            type: QUESTION_TRIP_COUNT,
            payload: data.code == 200 ? data.payload.count : 0
        })

        dispatch({
            type: QUESTION_TRIP,
            payload: data.code == 200 ? data.payload.data : 0,
        });

    }
}

export function getAnswerUser(id: any) {
    return async (dispatch: DispatchGeneral) => {
        let data;
        try {
            data = await authGet('auth/questions/get-my-answer/' + id);
        } catch (error) {
            data = { code: 201 };
        }
        dispatch({
            type: ANSWER_USER,
            payload: data.code == 200 ? data.payload.data : [],
        });

    }
}

export function getQuestionTripGuide(start?: any, list?: any) {
    return async (dispatch: DispatchGeneral) => {
        let data;
        try {
            data = await getAuth('auth/questions-product-guide?page=' + start);
        } catch (error) {
            data = { code: 201 }
        }

        let dataTrip;

        if (list) {
            dataTrip = list;
            if (data.code == 200) {
                data.payload.data.map((item: any, index: any) => {
                    dataTrip.push(item)
                })
            }

            if (data.payload.data.length == 0) {
                updateShowItemTrip(getShowItemTrip() - 1);
            }
        }
        dispatch({
            type: QUESTION_TRIP_GUIDE,
            payload: data.code == 200 ? list ? dataTrip : data.payload.data : [],
        });
    }
}

export function getQuestionGuide(id: any, start?: any, list?: any) {
    return async (dispatch: DispatchGeneral) => {
        let data;
        try {
            // data = await getAuth('auth/questions-guide?page='+start);
            data = await pubGet(`questions-trip/${id}?page=${start}`);
        } catch (error) {
            data = { code: 201 };
        }
        let dataQuestion;

        if (list) {
            dataQuestion = list;
            if (data.code == 200) {
                data.payload.data.map((item: any, index: any) => {
                    dataQuestion.push(item)
                })
            }
            if (data.payload.data.length == 0) {
                updateShowItem(getShowItem() - 1);
            }

        }
        setIsShowData(false);
        setIsShowLoading(false);

        dispatch({
            type: QUESTION_GUIDE,
            payload: data.code == 200 ? list ? dataQuestion : data.payload.data : [],
        });
    }
}

let textQuestion: any;
export function updateTextQuestion(val: string) {
    // console.log('ssssssssssssssssssssss',val);

    // return async (dispatch: DispatchGeneral) => {
    // console.log('11111111111',val);

    //     dispatch({
    //         type:QUESTION_TEXT,
    //         payload:val   
    //     })
    // }
    textQuestion = val
}

export function getTextQuestion() {
    return textQuestion;
}

let numberPage = 0;
let numberPageTrip = 0;
let isShowData = true;
let isShowLoading = false;
export function updateShowItem(val: number) {
    numberPage = val;
}

export function getShowItem() {
    return numberPage;
}

export function updateShowItemTrip(val: number) {
    numberPageTrip = val;
}

export function getShowItemTrip() {
    return numberPageTrip;
}


export function setIsShowData(val: boolean) {
    isShowData = val;
}

export function getIsShowData() {
    return isShowData;
}


export function setIsShowLoading(val: boolean) {
    isShowLoading = val;
}

export function getIsShowLoading() {
    return isShowLoading;
}



